export default {
  listAjustes: [],
  ajuste: {
    id: '',
    obs: '',
    conta: null,
    data: null,
    valor: 0.0,
    tipo: 'CREDITO',
  },
}
